import React from "react";
import { RadioButtonProps } from "../interfaces";

export const RadioButton: React.FC<RadioButtonProps> = (props) => {
  const { checked, className, disabled, label, onChange } = props;

  return (
    <label
      className={`flex w-fit select-none items-center gap-2 ${
        disabled ? "cursor-default opacity-50" : "cursor-pointer"
      }`}
    >
      <span className="relative flex h-4 w-4 items-center justify-center">
        <input
          type="radio"
          className="peer absolute h-4 w-4 cursor-pointer opacity-0 disabled:cursor-default"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <span
          className={`block h-4 w-4 rounded-full border border-black transition-colors duration-150 ${
            checked ? "bg-black" : "bg-white"
          }`}
        />
        {checked && (
          <span className="absolute h-1.5 w-1.5 rounded-full bg-white" />
        )}
      </span>
      <span className={`text-sm font-normal text-gray-900 ${className || ""}`}>
        {label}
      </span>
    </label>
  );
};
